import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import { useScrollLock } from "../../../hooks/useScrollLock"
import { useEffect, useState } from "react"
import PageTopTitle from "../../shared/PageTopTitle"
import iller from "../../../utils/iller"
import ilceler from "../../../utils/ilceler"
import {unCodes} from "../../../utils/un"
import {tasimaTuruOptions,yukunTuruOptions, bozulabilirGidaTuruOptions, normalYukBirimi, tehlikeliYukBirimi,tehlikeliMaddeTasimaTuruOptions} from "../../../utils/UETDSOptions"
import { showModal } from "../../../features/modal/modalSlice"
import { useLocation } from "react-router-dom"
import Button from "../../shared/button/Btn"
import { handleActiveSelect } from "../../../features/layout/layoutSlice"
import dateConverter from "../../../helper/dateConverter"
import { calcSeferSuresi } from "../../../helper/calcSeferSuresi"
import {deleteUetds, updateUETDS, updateUETDSAndSend, updateUETDSAndSendDanger, updateUETDSDanger } from "../../../features/admin/adminSlice"
import useTCNoValidation from "../../../hooks/useTCNoValidation"
import SmallSpinner from "../../shared/spinners/SmallSpinner"
import InputSelect from "../../shared/input/new/InputSelect"
import InputText from "../../shared/input/new/InputText"
import InputDate from "../../shared/input/new/InputDate"
import InputTime from "../../shared/input/new/InputTimeNew"
import InputNumberNew from "../../shared/input/new/InputNumberNew"
import InputCityTown from "../../shared/input/new/InputCityTown"
import locationData from "../../../utils/locationData/locationOptions"

const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 870px;
        max-width: 900px;
        height: 700px;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        padding-top: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .form{
            margin-top: 20px;
            display: flex;
            width: 100%;
            flex-direction: column;
            align-items: center;
            gap: 5px;
            height:570px;
            padding-bottom: 30px;
            overflow: auto;
            .row{
                padding-block: 8px;
                width: 50%;
                margin: 0 auto;
                .error{
                    font-size: 12px;
                    color: var(--color-main);
                }
            }
            &::-webkit-scrollbar {
                width: 0;
                width: 8px;
            }
            &::-webkit-scrollbar-thumb {
                background-color: #9e9b9b;
                border-radius: 10px;
            }
            &::-webkit-scrollbar-track {
                background-color: transparent;
            }

        }

        .message-container{
            height: 60px;
            display: flex;
            align-items: center;

            p{
                background-color: ${({isOkay})=> isOkay ?"#0080005f": "#bb264946"};
                padding:10px 20px;
                border-radius: 5px;
                font-size: 16px;
                border: 1px solid;
                border-color: ${({isOkay})=> isOkay ?"#0EAC00": "#BB2649"};
                color: ${({ theme }) => theme.mainTextColor};
                font-weight: var(--font-weight-md);
            }
        }

        .button-grp{
            height: 80px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: 10px;
            width: 640px;
            border-top: 1px solid;
            border-color: ${({ theme }) => theme.mainBorderColor};
            margin-right: 8px;
        }
    }
`
const UpdateUETDForLogisticModal = () => {

    const dispatch = useDispatch()
    const location = useLocation()
    const {UETDSItemData, isLoadingUpdateUETDS, isLoadingDeleteUetds, isLoadingUpdateUETDSAndSend} = useSelector(state => state.admin)
    const { validateTcKimlikNo } = useTCNoValidation();
    const {modalLocation } = useSelector(state => state.modal)
    const [isOkay, setIsOkay] = useState(false)

    const [message ,setMessage ] = useState("")
    const [isSubmitted, setIsSubmitted] = useState(false)
    // const [ requiredFields, setRequiredFields] = useState([])

    //! eğer yük tehlikeli madde ise un code lardan un coda karşılık gelen tehlikeli madde ismini bulacak
    const [dangerousItemName, setDangerousItemName] = useState(null)
    const [isValidUnId, setIsValidUnId] = useState(false)

    // update için sefer saati girilmediğinde api den gelen ilk başlangıç değeri olan bosaltma tarihi ve saati gelecek
    const [fixedBosaltmaTarih, setFixedBosaltmaTarih] = useState(UETDSItemData.bosaltmaTarihi)
    const [fixedBosaltmaSaat, setFixedBosaltmaSaat] = useState(UETDSItemData.bosaltmaSaati)

    const [fixedTasimaTuru, setfixedTasimaTuru] = useState(UETDSItemData.tasimaTuruKodu)

    const { lockScroll, unlockScroll } = useScrollLock();

    const [data, setData] = useState(UETDSItemData)


    //! select ones
    const [yuklemeIlAdi, setYuklemeIlAdi] = useState(locationData.find(item => item.town?.toLocaleLowerCase("tr") === data?.yuklemeIlceAdı?.toLocaleLowerCase("tr")))
    const [bosaltmaIlAdi, setBosaltmaIlAdi] = useState(locationData.find(item => item.town?.toLocaleLowerCase("tr") === data?.bosaltmaIlceAdı?.toLocaleLowerCase("tr")))

    const [yukCinsAdi, setYukCinsAdi] = useState({
        value: data.yukCinsId,
        text: data.yukCinsAdi
    })
    const [yukBirimi, setYukBirimi] = useState({
        value:data.yukBirimi,
        text:[...tehlikeliYukBirimi, ...normalYukBirimi].find((item)=> {
            return item.value === data.yukBirimi
        })?.text
    })

    
    const [tasimaTuru, setTasimaTuru] = useState({
        value: data.tasimaTuruKodu,
        text: data.tasimaTuruKodu === 1 ? "Tehlikeli Yük": "Normal Yük"
   })
   
    const [bozulabilirGidaTuru, setBozulabilirGidaTuru] = useState({
        value: "",
        text: ""
    })

    const [tehlikeliMaddeTasimaTuru, setTehlikeliMaddeTasimaTuru] = useState({
        value: data.tehlikeliMaddeTasimaTuru,
        text: tehlikeliMaddeTasimaTuruOptions.find((item)=> {
            return item.value === data.tehlikeliMaddeTasimaTuru
        })?.text
    })

    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])

    useEffect(()=> {
        if(data.seferSuresi < 1 && data.seferSuresi !== ""){
          setData((prev)=> ({...prev, seferSuresi: 1}))
        }
        if(data.seferSuresi > 48){
          setData((prev)=> ({...prev, seferSuresi: 48}))
        }
      },[data.seferSuresi])
      
      useEffect(()=> {
        if (data.seferSuresi){
            setData((prev)=> ({...prev, bosaltmaTarihi: calcSeferSuresi(parseInt(data.seferSuresi),data.yuklemeTarihi, data.yuklemeSaati).date, bosaltmaSaati: calcSeferSuresi(parseInt(data.seferSuresi),data.yuklemeTarihi, data.yuklemeSaati).time}))
        }
        else{
            setData((prev)=> ({...prev, bosaltmaTarihi:fixedBosaltmaTarih, bosaltmaSaati: fixedBosaltmaSaat}))
        }
     
      },[data.seferSuresi,data.yuklemeTarihi, data.yuklemeSaati])

    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])


    const handleChange = (e)=> {
        setData((prev)=> ({...prev, [e.target.name]: e.target.value}))
    }


   //! eğer ilgili yük tehlike madddeyse ve unId si varsa un Id ye karşılık gelen maddeye ulaşıyoruz.
   useEffect(()=> {
    if(data.unId){
        const dangerousItem = unCodes.find((item)=> {
            // eslint-disable-next-line
            return item["BAKANLIK_KOD"] == data.unId
        })
        if(dangerousItem){
            setDangerousItemName(dangerousItem["ORİJİNAL İSİM"])
            setIsValidUnId(true)
        }
        //! burayı düzenle burada kullanıcıya mesaj gönderecek ve unId kırmızı border olacak
        else{
            setDangerousItemName("Lütfen geçerli bir UN kodu girin.")
            setIsValidUnId(false)
        }
    }
   },[data.unId])

//    useEffect(()=> {
//     if(tasimaTuru.text === "Tehlikeli Yük"){
//         setRequiredFields(["tasimaTuru", "plaka1","tcKimlikNo1", "yuklemeTarihi", "yuklemeSaati","gondericiUnvan","gondericiVergiNo","aliciUnvan", "aliciVergiNo", "yuklemeIlAdi", "bosaltmaIlAdi", "bosaltmaTarihi", "bosaltmaSaati", "yukBirimi", "yukMiktarı", "tehlikeliMaddeTasimaTuru", "unId"])
//     }
//     else{
//         setRequiredFields(["tasimaTuru", "plaka1","tcKimlikNo1", "yuklemeTarihi", "yuklemeSaati","gondericiUnvan","aliciUnvan", "yuklemeIlAdi", "bosaltmaIlAdi", "bosaltmaTarihi", "bosaltmaSaati","yukCinsAdi", "yukBirimi", "yukMiktarı"])
//     }
// },[tasimaTuru.text])


//! bu kullanıcı tasıma türünü deiğiştirirse yük birimin sıfırlamak için
useEffect(()=> {
    if(tasimaTuru.value !== fixedTasimaTuru){
        setYukBirimi("")
    }
  },[tasimaTuru.value])

  useEffect(()=> {
    if(isSubmitted){
      if(tasimaTuru.text === "Tehlikeli Yük"){
        if(!tasimaTuru.value || !data.plaka1 || !data.tcKimlikNo1 || !data.yuklemeTarihi || !data.yuklemeSaati || !data.gondericiUnvan || !data.gondericiVergiNo || !data.aliciUnvan || !data.aliciVergiNo || !yuklemeIlAdi || !bosaltmaIlAdi || !data.bosaltmaTarihi || !data.bosaltmaSaati || !yukBirimi.value || !data.yukMiktarı || !tehlikeliMaddeTasimaTuru.value || !data.unId){
            setMessage(`Lütfen doldurması zorunlu alanları doldurun.`)
            setIsOkay(false)
        }
        else{
            if(!isValidUnId){
              setMessage(`Lütfen geçerli bir UN kodu giriniz.`)
              setIsOkay(false)
            }
            else{
              setMessage("")
              setIsOkay(true)
            }
          }
    }
  
    else if( tasimaTuru.text === "Normal Yük"){
        if(!tasimaTuru.value || !data.plaka1 || !data.tcKimlikNo1 || !data.yuklemeTarihi || !data.yuklemeSaati || !data.gondericiUnvan || !data.aliciUnvan || !yuklemeIlAdi || !bosaltmaIlAdi || !data.bosaltmaTarihi|| !data.bosaltmaSaati|| !yukCinsAdi || !yukBirimi.value || !data.yukMiktarı){
            setMessage(`Lütfen doldurması zorunlu alanları doldurun.`)
            setIsOkay(false)
        }
  
        else{
          setMessage("")
          setIsOkay(true)
        }
    }
    }
  },[tasimaTuru.value, data.plaka1, data.tcKimlikNo1, data.yuklemeTarihi, data.yuklemeSaati, data.seferSuresi, data.gondericiUnvan, data.gondericiVergiNo, data.aliciUnvan, data.aliciVergiNo, yuklemeIlAdi, bosaltmaIlAdi, data.bosaltmaTarihi, data.bosaltmaSaati, yukBirimi.value, data.yukMiktarı, tehlikeliMaddeTasimaTuru.value, data.unId, yukCinsAdi.value, isSubmitted, isValidUnId])
  

  useEffect(() => {
    if(bosaltmaIlAdi === "Elâzığ"){
        setBosaltmaIlAdi("Elazığ")
    }
  },[bosaltmaIlAdi])

const handleSubmitAndSend = () => {
    setIsSubmitted(true)
    if(tasimaTuru.text === "Tehlikeli Yük"){
        if(!tasimaTuru.value || !data.plaka1 || !data.tcKimlikNo1 || !data.yuklemeTarihi || !data.yuklemeSaati|| !data.gondericiUnvan || !data.gondericiVergiNo || !data.aliciUnvan || !data.aliciVergiNo || !yuklemeIlAdi || !bosaltmaIlAdi || !data.bosaltmaTarihi|| !data.bosaltmaSaati|| !yukBirimi.value || !data.yukMiktarı || !tehlikeliMaddeTasimaTuru.value || !data.unId){
            setMessage("Lütfen doldurması zorunlu alanları doldurun.")
            setIsOkay(false)
            return
        }
        else{
            if(!isValidUnId){
              setMessage(`Lütfen geçerli bir UN kodu giriniz.`)
              setIsOkay(false)
              return
            }
          }
    }

    else if( tasimaTuru.text === "Normal Yük"){
        if(!tasimaTuru.value || !data.plaka1 || !data.tcKimlikNo1 || !data.yuklemeTarihi || !data.yuklemeSaati|| !data.gondericiUnvan || !data.aliciUnvan || !yuklemeIlAdi || !bosaltmaIlAdi || !data.bosaltmaTarihi|| !data.bosaltmaSaati|| !yukCinsAdi.value || !yukBirimi.value || !data.yukMiktarı){
            setMessage("Lütfen doldurması zorunlu alanları doldurun.")
            setIsOkay(false)
            return
        }
    }

    //! eğer yukarıdaki koşulları geçerse
    delete data.seferSuresi

        const dataa={
            ...data,

            //! date leri us formatından tr ye aktarmak için
            yuklemeTarihi: dateConverter(data.yuklemeTarihi, "tr-2"),
            bosaltmaTarihi: dateConverter(data.bosaltmaTarihi, "tr-2"),

            //! selected ones
            yuklemeIlAdi: yuklemeIlAdi?.city,
            yuklemeIlceAdı: yuklemeIlAdi?.town,
            bosaltmaIlAdi: bosaltmaIlAdi?.city,
            bosaltmaIlceAdı: bosaltmaIlAdi?.town,
            tcKimlikNo1: validateTcKimlikNo(data.tcKimlikNo1) ? data.tcKimlikNo1: "123",
            yukCinsAdi: tasimaTuru.value === 2 ? yukCinsAdi.text: "",
            yukCinsId: tasimaTuru.value === 2 ? yukCinsAdi.value : 999,
            yukBirimi: yukBirimi.value,
            tehlikeliMaddeTasimaTuru: tasimaTuru.value === 1 ? tehlikeliMaddeTasimaTuru.value: "",
            tasimaTuruKodu: tasimaTuru.value,

            //! il ve ilçelerin mernis kodlarına ulaşmak için
            yuklemeIlMernisId: yuklemeIlAdi?.cityId,

            yuklemeIlceMernisKodu: yuklemeIlAdi?.townId,

            bosaltmaIlMernisKodu: bosaltmaIlAdi?.cityId,

            bosaltmaIlceMernisKodu: bosaltmaIlAdi?.townId,

            //! static benim elle koyduğum
            bosaltmaUlkeKodu: "TR",
            yuklemeUlkeKodu: "TR"
        }

        if(tasimaTuru.value === 1){
            dispatch(updateUETDSAndSendDanger(dataa))
        }

        if(tasimaTuru.value === 2){
            dispatch(updateUETDSAndSend(dataa))
        }
  }

  const handleSubmit = () => {
    setIsSubmitted(true)
    if(tasimaTuru.text === "Tehlikeli Yük"){
        if(!tasimaTuru.value || !data.plaka1 || !data.tcKimlikNo1 || !data.yuklemeTarihi || !data.yuklemeSaati|| !data.gondericiUnvan || !data.gondericiVergiNo || !data.aliciUnvan || !data.aliciVergiNo || !yuklemeIlAdi || !bosaltmaIlAdi || !data.bosaltmaTarihi|| !data.bosaltmaSaati|| !yukBirimi.value || !data.yukMiktarı || !tehlikeliMaddeTasimaTuru.value || !data.unId){
            setMessage("Lütfen doldurması zorunlu alanları doldurun.")
            setIsOkay(false)
            return
        }
        else{
            if(!isValidUnId){
              setMessage(`Lütfen geçerli bir UN kodu giriniz.`)
              setIsOkay(false)
              return
            }
          }
    }

    else if( tasimaTuru.text === "Normal Yük"){
        if(!tasimaTuru.value || !data.plaka1 || !data.tcKimlikNo1 || !data.yuklemeTarihi || !data.yuklemeSaati|| !data.gondericiUnvan || !data.aliciUnvan || !yuklemeIlAdi || !bosaltmaIlAdi || !data.bosaltmaTarihi|| !data.bosaltmaSaati|| !yukCinsAdi.value || !yukBirimi.value || !data.yukMiktarı){
            setMessage("Lütfen doldurması zorunlu alanları doldurun.")
            setIsOkay(false)
            return
        }
    }

    //! eğer yukarıdaki koşulları geçerse
    delete data.seferSuresi

        const dataa={
            ...data,

            //! date leri us formatından tr ye aktarmak için
            yuklemeTarihi: dateConverter(data.yuklemeTarihi, "tr-2"),
            bosaltmaTarihi: dateConverter(data.bosaltmaTarihi, "tr-2"),

            //! selected ones
            yuklemeIlAdi: yuklemeIlAdi?.city,
            yuklemeIlceAdı: yuklemeIlAdi?.town,
            bosaltmaIlAdi: bosaltmaIlAdi?.city,
            bosaltmaIlceAdı: bosaltmaIlAdi?.town,
            tcKimlikNo1: validateTcKimlikNo(data.tcKimlikNo1) ? data.tcKimlikNo1: "123",
            yukCinsAdi: tasimaTuru.value === 2 ? yukCinsAdi.text: "",
            yukCinsId: tasimaTuru.value === 2 ? yukCinsAdi.value : 999,
            yukBirimi: yukBirimi.value,
            tehlikeliMaddeTasimaTuru: tasimaTuru.value === 1 ? tehlikeliMaddeTasimaTuru.value: "",
            tasimaTuruKodu: tasimaTuru.value,

            //! il ve ilçelerin mernis kodlarına ulaşmak için
            yuklemeIlMernisId: (yuklemeIlAdi?.cityId === "341" || yuklemeIlAdi?.cityId === "342") ? "34" : yuklemeIlAdi?.cityId,

            yuklemeIlceMernisKodu: yuklemeIlAdi?.townId,

            bosaltmaIlMernisKodu: (bosaltmaIlAdi?.cityId === "341" || bosaltmaIlAdi?.cityId === "342") ? "34" : bosaltmaIlAdi?.cityId,

            bosaltmaIlceMernisKodu: bosaltmaIlAdi?.townId,

            //! static benim elle koyduğum
            bosaltmaUlkeKodu: "TR",
            yuklemeUlkeKodu: "TR"
        }

        if(tasimaTuru.value === 1){
            dispatch(updateUETDSDanger(dataa))
        }

        if(tasimaTuru.value === 2){
            dispatch(updateUETDS(dataa))
        }
  }

  return (
    <ModalContainer onClick={()=> dispatch(showModal(null))} isOkay={isOkay}>
        <div className="modal"  onClick={(e)=> {e.stopPropagation(); dispatch(handleActiveSelect(null))}}>
        <PageTopTitle title={"U-ETDS Yük Bildirimi Düzenle"}/>
        <div className="form">
            <div className="row">
                <InputSelect labelText={"Taşıma Türü Seçiniz"} initialOptions={tasimaTuruOptions} name={"tasimaTuru"} data={tasimaTuru?.text || tasimaTuru} setData={setTasimaTuru} />
                {
                    isSubmitted === true && !tasimaTuru &&
                    <span className="error">Zorunlu Alan</span>
                }
            </div>

            <div className="row">
                <InputText labelText={"Plaka"} name={"plaka1"} data={data.plaka1} setData={(e) => handleChange(e)} />
                {
                    isSubmitted === true && !data?.plaka1 &&
                    <span className="error">Zorunlu Alan</span>
                }
            </div>

            <div className="row">
                <InputText labelText={"Y.Römork - Römork Plakası"} name={"plaka2"} data={data.plaka2} setData={(e) => handleChange(e)} />
            </div>

            <div className="row">
                <InputText labelText={"Sürücü TC No"} name={"tcKimlikNo1"} data={data.tcKimlikNo1} setData={(e) => handleChange(e)} />
                {
                    isSubmitted === true && !data?.tcKimlikNo1 &&
                    <span className="error">Zorunlu Alan</span>
                }
            </div>
            
            <div className="row">
                <InputDate labelText={"Yükleme Tarihi"} name={"yuklemeTarihi"} data={dateConverter(data.yuklemeTarihi, "us-2")} setData={(e) => handleChange(e)} />
            </div>

            <div className="row">
                <InputTime labelText={"Yükleme Saati"} name={"yuklemeSaati"} data={data.yuklemeSaati} setData={(e) => handleChange(e)} />
            </div>

            <div className="row">
                <InputText labelText={"Tahmini Sefer Süresi"} name={"seferSuresi"} data={data.seferSuresi} setData={(e) => handleChange(e)} />
            </div>

            <div className="row">
                <InputDate labelText={"Boşaltma Tarihi"} name={"bosaltmaTarihi"} data={dateConverter(data.bosaltmaTarihi, "us-2")} setData={(e) => handleChange(e)} />
            </div>

            <div className="row">
                <InputTime labelText={"Boşaltma Saati"} name={"bosaltmaSaati"} data={data.bosaltmaSaati} setData={(e) => handleChange(e)} />
            </div>

            <div className="row">
                <InputText labelText={"Gönderen Adı / Ünvanı"} name={"gondericiUnvan"} data={data.gondericiUnvan} setData={(e) => handleChange(e)} />
                {
                    isSubmitted === true &&  !data?.gondericiUnvan && tasimaTuru.text === "Tehlikeli Yük" &&
                    <span className="error">Zorunlu Alan</span>
                }
            </div>

            <div className="row">
                <InputNumberNew labelText={"Gönderen Vergi Numarası"} name={"gondericiVergiNo"} data={data.gondericiVergiNo} setData={(e) => handleChange(e)} />
                {
                    isSubmitted === true && tasimaTuru.text === "Tehlikeli Yük" && !data?.gondericiVergiNo &&
                    <span className="error">Zorunlu Alan</span>
                }
            </div>

            <div className="row">
                <InputText labelText={"Alıcı Adı / Ünvanı"} name={"aliciUnvan"} data={data.aliciUnvan} setData={(e) => handleChange(e)} />
                {
                    isSubmitted === true && tasimaTuru.text === "Tehlikeli Yük" && !data?.aliciUnvan &&
                    <span className="error">Zorunlu Alan</span>
                }
            </div>

            <div className="row">
                <InputNumberNew labelText={"Alıcı Vergi Numarası"} name={"aliciVergiNo"} data={data.aliciVergiNo} setData={(e) => handleChange(e)} />
                {
                    isSubmitted === true  && !data?.aliciVergiNo && tasimaTuru.text === "Tehlikeli Yük" &&
                    <span className="error">Zorunlu Alan</span>
                }
            </div>

            <div className="row">
                <InputCityTown labelText={"Yükleme İl / İlçe"} initialOptions={locationData} name={"yuklemeIlAdi"} data={yuklemeIlAdi?.location} setData={setYuklemeIlAdi} />
                {
                    isSubmitted === true  && !yuklemeIlAdi &&
                    <span className="error">Zorunlu Alan</span>
                }
            </div>

            <div className="row">
                <InputCityTown labelText={"Boşaltma İl / İlçe"} initialOptions={locationData} name={"bosaltmaIlAdi"} data={bosaltmaIlAdi?.location} setData={setBosaltmaIlAdi} />
                {
                    isSubmitted === true  && !bosaltmaIlAdi &&
                    <span className="error">Zorunlu Alan</span>
                }
            </div>

            {
                tasimaTuru.text !== "Tehlikeli Yük" &&
                <div className="row">
                    <InputSelect initialOptions={yukunTuruOptions} labelText={"Yükün Türü"} data={yukCinsAdi?.text} name={"yukCinsAdi"} setData={setYukCinsAdi} />
                {
                    isSubmitted === true &&  !yukCinsAdi?.text &&
                    <span className="error">Zorunlu Alan</span>
                }
                </div>
            }

            {
                //! yukun cinsi bozulabilir gıda ise görünecek
                yukCinsAdi.text === "Bozulabilir Gıda"&&
                <div className="row">
                    <InputSelect initialOptions={bozulabilirGidaTuruOptions} labelText={"Bozulabilir Gıda Türü"} data={bozulabilirGidaTuru?.text || bozulabilirGidaTuru} name={"bozulabilirGidaTuru"} setData={setBozulabilirGidaTuru} />
                </div>
            }

            {
                //! tasima türü normal yük ise normal yük optionsları, tehlikeli yük ise tehlikeli yük optionsları gözükecek
                tasimaTuru.text &&
                <div className="row">
                    <InputSelect initialOptions={tasimaTuru.text === "Normal Yük" ? normalYukBirimi : tehlikeliYukBirimi} labelText={"Yükün Birimi"} data={yukBirimi?.text || yukBirimi} name={"yukBirimi"} setData={setYukBirimi} />

                </div>
            }
            
            <div className="row">
                <InputNumberNew labelText={"Yükün Miktarı"} name={"yukMiktarı"} data={data.yukMiktarı} setData={(e) => handleChange(e)}  />
                {
                    isSubmitted === true && !data.yukMiktarı &&
                    <span className="error">Zorunlu Alan</span>
                }
            </div>

            <div className="row">
                <InputNumberNew labelText={"Nakliye Bedeli"} name={"tasimaBedeli"} data={data.tasimaBedeli} setData={(e) => handleChange(e)}  />
            </div>
            
            {
                //! tasima türü tehlikeli yük ise veya unkodu var ise tehlikeli madde tasima sekil optionslari gözükecek
                (tasimaTuru.text === "Tehlikeli Yük" && data.unId) &&
                <div className="row">
                    <InputSelect initialOptions={tehlikeliMaddeTasimaTuruOptions} labelText={"Tehlikeli Madde Taşıma Şekli"} data={tehlikeliMaddeTasimaTuru || tehlikeliMaddeTasimaTuru?.text} name={"tehlikeliMaddeTasimaTuru"} setData={setTehlikeliMaddeTasimaTuru} />
                {
                    isSubmitted === true && tasimaTuru.text === "Tehlikeli Yük" && !tehlikeliMaddeTasimaTuru &&
                    <span className="error">Zorunlu Alan</span>
                }
                </div>
            }

            {
                //! unId varsa veya tasima türü Tehlikeli Yük ise unId input u gözükecek
                (tasimaTuru.text === "Tehlikeli Yük") &&
                <div className="row">
                    <InputText data={data?.unId} setData={(e) => handleChange(e)} labelText={"Un Kodu*"} name={"unId"} />
                </div>
            }

            {
                 //! unId si olan tehlikeli bir yük ise maddenin ismini yazdırıyor
                 (data.unId && tasimaTuru.text === "Tehlikeli Yük") &&
                 <div className="row">
                    <InputText disabled={true} data={dangerousItemName} labelText={"Tehlikeli Madde"} />
                 </div>
            }
        </div>

        {message &&
        <div className='message-container'>
            <p>{message}</p>
        </div>
        }
        <div className='button-grp'>
            <Button color={"#E85546"} background={"transparent"} width="280px" radius={"10px"} padding="0 10px" handleClick={() => {handleSubmit()}}>{isLoadingUpdateUETDS ? <SmallSpinner size={"20px"} color={"#fff"} bgColor={"#E85446"}/> : "Güncelle"}</Button>
            {/* <Button color={"#E85546"} background={"transparent"} width="390px" radius={"10px"} padding="0 10px" handleClick={()=> {handleSubmitAndSend()}}>{isLoadingUpdateUETDSAndSend ? <SmallSpinner size={"20px"} color={"#fff"} bgColor={"#E85446"}/> : "Güncelle ve U-ETDS Gönder"}</Button> */}
            <Button color={"#E85546"} background={"transparent"} width="160px" radius={"10px"} padding="0 10px" handleClick={()=> dispatch(showModal(null))}>Geri Dön</Button>
            <Button color={"#E85546"} background={"transparent"} width="160px" radius={"10px"} padding="0 10px" handleClick={()=> {dispatch(deleteUetds({id: data.id})); dispatch(showModal(null))}}>{isLoadingDeleteUetds ? "" : "Sil"}</Button>
        </div>
        </div>
    </ModalContainer>
  )
}

export default UpdateUETDForLogisticModal